export default __webpack_public_path__ + "static/media/MR.7acd10a8.svg";